import api from './api';

export interface User {
  id: string;
  fullName: string;
  email: string;
  phoneNumber?: string;
  status: string;
  createdAt: string;
  isVerified: boolean;
}

export interface UserListResponse {
  users: User[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export async function getUserList(page: number = 1, pageSize: number = 100): Promise<User[]> {
  try {
    const response = await api.get(`/admin/users?page=1&pageSize=${pageSize}`);
    return response.data.users || [];
  } catch (error) {
    console.error('Error fetching users:', error, page);
    return [];
  }
}

export async function getUsersWithPushTokens(page: number = 1, pageSize: number = 100): Promise<User[]> {
  try {
    const response = await api.get(`/admin/users/with-push-tokens?page=${page}&pageSize=${pageSize}`);
    return response.data.users || [];
  } catch (error) {
    console.error('Error fetching users with push tokens:', error);
    return [];
  }
}

export async function getUserById(id: string): Promise<User | null> {
  try {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    return null;
  }
}
